import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    AddProductForLead as AddProductForLeadMutation,
    AddProductForLeadVariables,
    LeadProductAddInput,
} from 'nutshell-graphql-types';

import ADD_PRODUCT_FOR_LEAD from '../mutations/add-product-for-lead.graphql';

export const useAddProductForLead = (): {
    addProductForLead: (arg1: LeadProductAddInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [addProductForLead, {loading, error}] = useMutation<
        AddProductForLeadMutation,
        AddProductForLeadVariables
    >(ADD_PRODUCT_FOR_LEAD);

    return {
        addProductForLead: (input: LeadProductAddInput) => addProductForLead({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
